export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"},{"name":"apple-mobile-web-app-title","content":"Rudiments"},{"name":"format-detection","content":"telephone=no"},{"name":"description","hid":"description","content":""},{"name":"og:locale","hid":"og:locale","content":"en_US"},{"name":"og:type","hid":"og:type","content":"website"},{"name":"og:site_name","hid":"og:site_name","content":"Drum Rudiments"}],"link":[{"rel":"preconnect","href":"https://db.drumrudiments.app"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"preconnect","href":"https://media.drumrudiments.app"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"shortcut icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","type":"image/png","sizes":"57x57","href":"/apple-icon-57x57.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"60x60","href":"/apple-icon-60x60.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"72x72","href":"/apple-icon-72x72.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"76x76","href":"/apple-icon-76x76.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"114x114","href":"/apple-icon-114x114.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"120x120","href":"/apple-icon-120x120.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"144x144","href":"/apple-icon-144x144.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"152x152","href":"/apple-icon-152x152.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"180x180","href":"/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"144x144","href":"/android-icon-144x144.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[{"src":"https://analytics.ahrefs.com/analytics.js","data-key":"gQ9iDT4WFb9JHQ/yty4pXQ","async":true},{"innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag() { \n              dataLayer.push(arguments);\n            }\n            gtag(\"consent\", \n              \"default\", {\n                \"ad_storage\": \"denied\",\n                \"ad_user_data\": \"denied\",\n                \"ad_personalization\": \"denied\",\n                \"analytics_storage\": \"denied\",\n                \"functionality_storage\": \"denied\",\n                \"personalization_storage\": \"denied\", \n                \"security_storage\": \"denied\"\n              }\n            );\n          "},{"src":"https://app.getterms.io/cookie-consent/embed/afc27cbe-69c2-4e23-83f4-097301515431/en-au","async":true}],"noscript":[],"title":"Drum Rudiments","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false